export default {
  zh: {
    emailLogin: '邮箱',
    phoneLogin: '手机号码',
    newToPlex: '新用户？前往',
    signUp: '注册'
  },
  en: {
    emailLogin: 'Email',
    phoneLogin: 'Phone',
    newToPlex: 'New to PlexVPN? ',
    signUp: 'Register'
  }
}



// WEBPACK FOOTER //
// ./src/views/auth/login/lang.js